import { units } from '@ui/css';
import { combineTokens, makeBreakpoint, makeSelectors } from '@utils/css';
import { makeSizeTokens } from '@utils/react/selectors';

const actionsSize = makeSizeTokens("--actions", units.px(101));

// NB: The i-ark component boundary (header + bullets) are styled somewhat
// differently from other component-framework components in order to better
// account for the bullets which are placed in the header. (Which isn't the
// case for other component-framework components.)

const tokens = combineTokens("--i-ark", {
  paddingInline: 0,
  paddingBlock: 0,
  firstPageAspectRatio: 1
});
const mobileLightboxLayoutBreakpoint = makeBreakpoint(0, 1280);
const root = "_086r1rvyjqv";
const wrapper = "_086wjkq7bi";
const header = "_086h1u1ykyf";
const headingWrapper = "_086h1xaw36y";
const headerToolsWrapper = "_086h1v96sxa";
const contextMenu = "_086c1etveo3";
const saveIndicatorPlaceholder = "_086s14c5u3w";
const saveIndicatorWrapper = "_086s1ovmp1p";
const saveIndicator = "_086sgtad8g";
const bullets = "_086b1l5s8ju";
const actionsWrapper = "_086a1szm102";
const elementToolbarPlaceholder = "_086e1uouhhh";
const actions = "_086a1pl9d7p";
const contentWrapper = "_086c1h25c48";
const fullscreenNavigationButton = "_086f60dzv0";
const fullscreenCloseButton = "_086fz9grmk";
const bottomContext = "_086b7m80rz";
const tools = "_086tcfcjpl";
const overlayContainer = "_086o1x5boqq";
const selectors = makeSelectors({
  wrapper,
  titleWrapper: header
});

export { actions, actionsSize, actionsWrapper, bottomContext, bullets, contentWrapper, contextMenu, elementToolbarPlaceholder, fullscreenCloseButton, fullscreenNavigationButton, header, headerToolsWrapper, headingWrapper, mobileLightboxLayoutBreakpoint, overlayContainer, root, saveIndicator, saveIndicatorPlaceholder, saveIndicatorWrapper, selectors, tokens, tools, wrapper };
import "./_component.style.linaria.module.css";
//# sourceMappingURL=_component.style.js.map
